import { useState, useEffect } from 'react';
import { StyleSheetManager, ThemeProvider } from 'styled-components';

import { api } from 'api';
import { user, data } from 'services';
import { Router } from 'router/router';
import { Loader } from 'libs/ui';
import { notify } from 'libs/common';
import { useTheme } from 'hooks';
import { KeyInterceptor } from 'libs/common/key-interceptor';
import { GlobalStyle } from './app.styled';

export const App = () => {
  const [checked, setChecked] = useState(false);
  const [logined, setLogined] = useState(false);
  const [ready, setReady] = useState(false);
  const { theme } = useTheme();

  /**
   * check user token
   */
  useEffect(() => {
    user
      .getInfo()
      .then(() => {
        setLogined(user.isLogined);
        setChecked(true);
      })
      .catch((error) => {
        notify('Ошибка сети', error);
        // setError(error);
        setLogined(false);
        setChecked(true);
      });
  }, []);

  /**
   * load data
   */
  useEffect(() => {
    const getData = async () => {
      try {
        let items = await api.call('dictionaries.list');
        data.setDictionaries(items);

        items = await api.call('zones.list');
        data.setZones(items);

        setReady(true);
      } catch (e) {
        notify('Ошибка получения данных', e.toString());
      }
    };

    if (logined) {
      getData();
    }
  }, [logined]);

  const notReady = !checked || (checked && logined && !ready);
  const filterProps = (prop) => {
    return ![
      'minWidth',
      'status',
      'brdColor',
      'justifyContent',
      'isActive',
      'selectedTab',
      'withSort',
      'renderCell',
      'innerRef',
      'bold',
      'left',
      'right',
      'final',
      'number',
      'isSelected',
      'wide',
      'ml0',
      'regular_only',
    ].includes(prop);
  };
  // console.log('🚀 ~ App ~ checked:', checked, logined);
  // console.log('theme', theme);

  return (
    <StyleSheetManager shouldForwardProp={filterProps}>
      <ThemeProvider theme={{ theme }}>
        <GlobalStyle />
        <div className="App">
          {notReady ? (
            <Loader />
          ) : (
            <>
              <KeyInterceptor />
              <Router logined={logined} />
            </>
          )}
        </div>
      </ThemeProvider>
    </StyleSheetManager>
  );
};
